import Vue from 'vue';
import permitService from '@/api/permit-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';
import { removeArrayItem } from '@/util/array';

const state = {
  parkingPermits: null,
  parkingPermitsPagination: {},
  editedParkingPermit: {},
  parkingPermitValidationErrors: {},
  parkingPermitFilterParams: {},
};

const mutations = {
  SET_PARKING_PERMITS(state, { data, meta }) {
    state.parkingPermits = data;
    state.parkingPermitsPagination = {
      current_page: meta.current_page,
      per_page: meta.per_page,
      total: meta.total,
    };
  },

  SET_PARKING_PERMIT_FILTER_PARAMS(state, params) {
    state.parkingPermitFilterParams = params;
  },

  SET_EDITED_PARKING_PERMIT(state, parkingPermit) {
    state.parkingPermitValidationErrors = {};
    state.editedParkingPermit = JSON.parse(JSON.stringify(parkingPermit));
    state.editedParkingPermit.need_to_clarify = parkingPermit.applicant_user.person.full_name;
  },

  APPROVE_PARKING_PERMIT(state, parkingPermit) {
    if (!parkingPermit.approved_parking_rules) {
      return;
    }
    state.parkingPermits = removeArrayItem(state.parkingPermits, parkingPermit);
  },

  SET_PARKING_PERMIT_VALIDATION_ERRORS(state, parkingPermitValidationErrors) {
    state.parkingPermitValidationErrors = parkingPermitValidationErrors;
  },

  CLEAR_PARKING_PERMIT_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.permitPriceValidationErrors, field);
  },
};

const actions = {
  fetchParkingPermits({ commit }, params) {
    commit('SET_PARKING_PERMIT_FILTER_PARAMS', params);
    return permitService.getParkingInfoPage(params).then((res) => {
      commit('SET_PARKING_PERMITS', res.data);
      if (params.page !== state.parkingPermitFilterParams.page) {
        window.scrollTo(0, 0);
      }
      return res.data;
    });
  },

  editParkingPermit({ state, commit }, parkingPermitId) {
    const parkingPermit = state.parkingPermits?.find((c) => c.id === parkingPermitId);
    if (parkingPermit) {
      commit('SET_EDITED_PARKING_PERMIT', parkingPermit);
      return Promise.resolve(parkingPermit);
    }
    return permitService.getById(parkingPermitId).then((res) => {
      commit('SET_EDITED_PARKING_PERMIT', res.data.data);
      return res.data.data;
    });
  },

  approveParkingInfo({ commit }, parkingPermit) {
    return permitService
      .approveParkingInfo(parkingPermit)
      .then((res) => {
        commit('APPROVE_PARKING_PERMIT', res.data.data);
        if (parkingPermit.approved_parking_rules === false) {
          eventBus.$emit(OPEN_SNACKBAR, i18n.t('parking_permit_rejected'));
        } else if (parkingPermit.approved_parking_rules === null) {
          eventBus.$emit(OPEN_SNACKBAR, i18n.t('parking_permit_unchanged'));
        } else {
          eventBus.$emit(OPEN_SNACKBAR, i18n.t('parking_permit_approved'));
        }
        return res.data.data;
      })
      .catch((err) => {
        commit('SET_PARKING_PERMIT_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearParkingPermitValidationErrors({ commit }, field) {
    commit('CLEAR_PARKING_PERMIT_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
